import { z } from 'zod';
import dayjs from 'dayjs';
import { OrganizationType } from 'src/Enum/EsgGreenhouse';
import {
  EMPTY_FIELD_MESSAGE,
  validateSpaceTextInput,
  validateTextEn,
} from '@Utils/validation';

enum CARBON_MODAl_FORM_MESSAGE {
  SCOPE = 'กรุณาระบุขอบเขตการปล่อยก๊าซเรือนกระจก',
  GOAL_YEAR = 'กรุณาระบุปีเป้าหมาย',
  GAS_EMISSION_PERCENTAGE = 'จำนวนไม่ถูกต้อง',
  ORGANIZATION_GUARANTEE = 'กรุณาเลือก',
  ORGANIZATION_LIST = 'กรุณาเลือกรายชื่อองค์กรหรือสถาบันที่รับรอง ความเป็นกลางทางคาร์บอนของบริษัท',
  ORGANIZATION_NAME = 'กรุณาระบุชื่อองค์กรหรือสถาบันที่รับรองความเป็นกลางทางคาร์บอนของบริษัท',
  ORGANIZATION_NAME_EN = 'กรุณาระบุชื่อองค์กรหรือสถาบันที่รับรองความเป็นกลางทางคาร์บอนของบริษัทเป็นภาษาอังกฤษ',
  REMARK_EN = 'กรุณาระบุหมายเหตุเป็นภาษาอังกฤษ',
}

const yearSchema = z.custom(
  (value) => dayjs.isDayjs(value) && value.isValid(),
  {
    message: CARBON_MODAl_FORM_MESSAGE.GOAL_YEAR,
  }
);

const gasEmissionQuantitySchema = z
  .union([z.string(), z.number()])
  .transform((value) => Number(value))
  .optional();

const gasEmissionPercentSchema = z
  .union([z.string(), z.number()])
  .transform((value) => Number(value))
  .refine((value) => value >= 0 && value <= 100, {
    message: CARBON_MODAl_FORM_MESSAGE.GAS_EMISSION_PERCENTAGE,
  })
  .optional();

export const modalAddCarbonValidationSchema = z
  .object({
    id: z.number().optional(),
    scopeId: z.number({ message: CARBON_MODAl_FORM_MESSAGE.SCOPE }),
    baseYear: z
      .object({
        year: yearSchema.optional().nullable(),
        gasEmissionQuantity: gasEmissionQuantitySchema.nullable(),
      })
      .optional(),
    target: z.object({
      year: yearSchema,
      gasEmissionPercent: gasEmissionPercentSchema.optional(),
      gasEmissionQuantity: gasEmissionQuantitySchema.optional(),
    }),
    isGuarantee: z.union([z.string(), z.boolean()]),
    organizationId: z.union([z.string(), z.number()]).optional(),
    organizationTh: z
      .string()
      .refine(validateSpaceTextInput, EMPTY_FIELD_MESSAGE.SPACE_BAR)
      .optional(),
    organizationEn: z
      .string()
      .regex(validateTextEn, {
        message: CARBON_MODAl_FORM_MESSAGE.ORGANIZATION_NAME_EN,
      })
      .refine(validateSpaceTextInput, EMPTY_FIELD_MESSAGE.SPACE_BAR)
      .optional(),
  })
  .superRefine((data, ctx) => {
    if (data.isGuarantee === true && data.organizationId === '') {
      ctx.addIssue({
        code: 'custom',
        path: ['organizationId'],
        message: CARBON_MODAl_FORM_MESSAGE.ORGANIZATION_GUARANTEE,
      });
    }

    if (
      data.isGuarantee === true &&
      data.organizationId === OrganizationType.OTHER_GHG_MGNT_ORGANIZATION
    ) {
      if (!data.organizationTh || data.organizationTh.trim() === '') {
        ctx.addIssue({
          code: 'custom',
          path: ['organizationTh'],
          message: CARBON_MODAl_FORM_MESSAGE.ORGANIZATION_NAME,
        });
      }

      if (!data.organizationEn || data.organizationEn.trim() === '') {
        ctx.addIssue({
          code: 'custom',
          path: ['organizationEn'],
          message: CARBON_MODAl_FORM_MESSAGE.ORGANIZATION_NAME,
        });
      }
    }
  });
